import React, { Component } from "react";
import products from "./productData";
import ProductTable from "./ProductTable";
import { connect } from "react-redux";

class ProductRender extends Component {
  render() {
    const proteinTable = this.props.products[0].proteins.map(item => (
      <ProductTable
        key={item.id}
        item={item}
        macro={this.props.userInfo.proteins}
        meals={this.props.userInfo.meals}
      />
    ));
    const carbsTable = this.props.products[0].carbs.map(item => (
      <ProductTable
        key={item.id}
        item={item}
        macro={this.props.userInfo.carbs}
        meals={this.props.userInfo.meals}
      />
    ));
    const fatTable = this.props.products[0].fat.map(item => (
      <ProductTable
        key={item.id}
        item={item}
        macro={this.props.userInfo.fat}
        meals={this.props.userInfo.meals}
      />
    ));
    const proteinFatTable = this.props.products[0].proteinFat.map(item => (
      <ProductTable
        key={item.id}
        item={item}
        macro={this.props.userInfo.fat * 9 + this.props.userInfo.proteins * 4}
        meals={this.props.userInfo.meals}
      />
    ));
    return (
      <div className="row justify-content-center text-center">
        <table className="table table-striped table-bordered table-hover table-sm col-11 col-lg-5">
          <thead className="thead-dark">
            <tr>
              <th colSpan="2">Proteins</th>
            </tr>
            <tr>
              <th className='product-width'>Product</th>
              <th className='grams-width'>Grams per meal</th>
            </tr>
          </thead>
          <tbody>{proteinTable}</tbody>
        </table>
        <table className="table table-striped table-bordered table-hover table-sm col-11 col-lg-5">
          <thead className="thead-dark">
            <tr>
              <th colSpan="2">Carbs</th>
            </tr>
            <tr>
              <th className='product-width'>Product</th>
              <th className='grams-width'>Grams per meal</th>
            </tr>
          </thead>
          <tbody>{carbsTable}</tbody>
        </table>
        <table className="table table-striped table-bordered table-hover table-sm col-11 col-lg-5">
          <thead className="thead-dark">
            <tr>
              <th colSpan="2">Fat</th>
            </tr>
            <tr>
              <th className='product-width'>Product</th>
              <th className='grams-width'>Grams per meal</th>
            </tr>
          </thead>
          <tbody>{fatTable}</tbody>
        </table>
        <table className="table table-striped table-bordered table-hover table-sm col-11 col-lg-5">
          <thead className="thead-dark">
            <tr>
              <th colSpan="2">Protein-fat</th>
            </tr>
            <tr>
              <th className='product-width'>Product</th>
              <th className='grams-width'>Grams per meal</th>
            </tr>
          </thead>
          <tbody>{proteinFatTable}</tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userInfo: state.userInfo,
  products: products
});

export default connect(mapStateToProps)(ProductRender);
